import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import PostDetail from "./components/PostDetail";
import CreatePost from "./pages/CreatePost";
// import EditPost from "./pages/EditPost"; // Commented out for now
import Login from "./pages/Login";
import SignUp from "./pages/SignUp"; // Import SignUp component
import Header from "./components/Header";
import Footer from "./components/Footer";
import FilteredPosts from "./pages/FilteredPosts"; // Commented out for now
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Header />
      <div className="container-fluid">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/post/:postId" element={<PostDetail />} />
          <Route path="/create" element={<CreatePost />} />
          {/* <Route path="/edit/:postId" element={<EditPost />} /> */} {/* Commented out */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/tags/:tag" element={<FilteredPosts />} /> {/* Commented out */}
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
